import { TreeNode } from '../route-builder';

export const MercerSupportModule = {
  segment: 'mercer-support',
  children: { MercerSupportListViewComponent: { segment: 'list-view', params: ['seasonId', 'filter', 'tags'] } }
} as const satisfies TreeNode;
